import { motion } from "framer-motion";
import { useState } from "react";

export default function WaveButton({ children, onClick, disabled, className, type = "button" }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`relative overflow-hidden ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {/* Efecto de onda */}
      <motion.div
        className="absolute inset-0 bg-white/20"
        initial={{ x: "-100%", skewX: -15 }}
        animate={
          isHovered
            ? {
                x: "100%",
                transition: {
                  duration: 0.6,
                  ease: "easeInOut",
                },
              }
            : { x: "-100%" }
        }
      />
      
      {/* Contenido del botón */}
      <span className="relative z-10">{children}</span>
    </motion.button>
  );
}
